import { Replay } from '@mui/icons-material';
import './Version.scss';

const Version = () => {
  const hardReload = () => {
    globalThis.location.reload(true);
  };

  return (
    <div className='version' onClick={hardReload}>
      v2.0.54
      <Replay className='version__reload-icon' />
    </div>
  )
};

export default Version;
